import fs from 'fs';
import fsPromises from 'fs/promises';
import path from 'path';
import { findProjectRoot } from '@ms-cloudpack/path-utilities';
// This module doesn't actually provide named exports for functions (types are wrong)
import yarnLock, { type LockFileObject } from '@yarnpkg/lockfile';

/**
 * Read and parse the yarn v1 lock file at the project root (usually git root), if it exists.
 * @param cwd Find the project root from here.
 * @returns Parsed lock file contents if repo uses yarn v1 and parsing was successful,
 * or an error message otherwise.
 */
export async function readYarnLock(cwd: string): Promise<string | LockFileObject> {
  const projectRoot = findProjectRoot(cwd);

  if (!projectRoot) {
    return `Project or package root not found relative to ${cwd}`;
  }

  const yarnLockPath = path.join(projectRoot, 'yarn.lock');
  if (!fs.existsSync(yarnLockPath)) {
    return `${yarnLockPath} not found (this command only works with Yarn 1)`;
  }

  const lockContents = await fsPromises.readFile(yarnLockPath, 'utf8');
  if (!lockContents.includes('# yarn lockfile v1')) {
    return 'This command only works with Yarn 1';
  }

  const lockfile = yarnLock.parse(lockContents);
  if (lockfile.type === 'success') {
    return lockfile.object;
  }

  return `Error parsing lockfile (${lockfile.type})`;
}
